import { Reveal } from "./Reveal";

const STEPS = [
  {
    step: "01",
    title: "A quick hello",
    desc: "A relaxed 15-minute chat on WhatsApp or the phone about what you're hoping to do.",
  },
  {
    step: "02",
    title: "I search the market",
    desc: "I'll compare 90+ lenders and get your agreement in principle — usually within 24 hours.",
  },
  {
    step: "03",
    title: "I do the paperwork",
    desc: "Application, underwriting, valuation — I'll manage it all and keep you posted.",
  },
  {
    step: "04",
    title: "Offer & moving day",
    desc: "Your offer lands, I coordinate with the solicitors, and you get the keys.",
  },
];

export default function Process() {
  return (
    <section id="process" data-testid="process-section" className="py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal className="max-w-2xl mb-14">
          <p className="font-mono text-xs tracking-[0.3em] uppercase text-amber-400/90 mb-5">
            How It Goes
          </p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight font-medium text-white leading-tight">
            From first message to moving day.
          </h2>
        </Reveal>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {STEPS.map((s, i) => (
            <Reveal key={s.step} delay={i * 0.1}>
              <div
                data-testid={`process-step-${i}`}
                className="group relative h-full rounded-3xl border border-white/10 bg-[#073B4C] p-8 transition-all duration-300 hover:-translate-y-1 hover:border-amber-400/40"
              >
                <p className="font-mono text-4xl font-semibold text-amber-400/25 group-hover:text-amber-400/60 transition-colors duration-300">
                  {s.step}
                </p>
                <h3 className="mt-6 font-display text-xl font-medium text-white">
                  {s.title}
                </h3>
                <p className="mt-3 text-sm text-slate-400 leading-relaxed">
                  {s.desc}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
